import { connect } from 'react-redux';
//import { actions } from '../../../redux/modules/oppeningClosingBox';
import { actions } from '../../../redux/modules/sales';

import Sales from './Sales';
import {resetStore} from "../../../redux/modules/login";

const ms2p = (state) => {
    return {
        ...state.sales,
    };
};

const md2p = { ...actions, resetStore };
export default connect(ms2p, md2p)(Sales);
